import SectionHeading from "@/components/shared/SectionHeading";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import {
  MortgageCalculator,
  SalesProceedsCalculator,
  PurchaseCalculator,
} from "@/components/calculators/Calculators";

export default function CalculatorsSection({ withHeading = true }) {
  return (
    <section data-testid="calculators-section" className="section-pad bg-beige/60">
      <div className="container-page">
        {withHeading && (
          <SectionHeading
            eyebrow="Calculators"
            title={<>Run the <span className="italic text-bronze">numbers</span> — quickly.</>}
            sub="Three Singapore-focused estimators — mortgage repayment, sales proceeds, and total cost of purchase. Results are indicative only."
          />
        )}
        <div className={withHeading ? "mt-12" : ""}>
          <Tabs defaultValue="mortgage" className="w-full">
            <TabsList
              data-testid="calc-tabs"
              className="flex flex-wrap gap-2 h-auto bg-transparent justify-start p-0 mb-10"
            >
              {[
                { v: "mortgage", l: "Mortgage Calculator" },
                { v: "sales", l: "Sales Proceeds" },
                { v: "purchase", l: "Purchase Calculator" },
              ].map((t) => (
                <TabsTrigger
                  key={t.v}
                  value={t.v}
                  data-testid={`calc-tab-${t.v}`}
                  className="px-5 py-2.5 text-[0.7rem] tracking-[0.22em] uppercase border border-bronze/30 bg-cream text-ink_soft data-[state=active]:bg-bronze data-[state=active]:text-cream data-[state=active]:border-bronze rounded-none"
                >
                  {t.l}
                </TabsTrigger>
              ))}
            </TabsList>

            <div className="bg-cream border border-bronze/20 p-7 md:p-10">
              <TabsContent value="mortgage"><MortgageCalculator /></TabsContent>
              <TabsContent value="sales"><SalesProceedsCalculator /></TabsContent>
              <TabsContent value="purchase"><PurchaseCalculator /></TabsContent>
            </div>
          </Tabs>
        </div>
      </div>
    </section>
  );
}
